import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  message,
  InputNumber,
  DatePicker,
  Spin,
} from "antd";
import "dayjs/locale/en";
import locale from "antd/es/date-picker/locale/en_US";
import BackRouteButton from "src/common/components/BackRouteButton";

import "./index.css";

export default ({ createRepair, profile }) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    values.creatorId = profile._id;

    const result = await createRepair(values);
    if (result.success) {
      form.resetFields();
      message.success("Repair successfully saved!");
      history.goBack();
    } else {
      message.error(result.message || "Failed to save repair!");
      setLoading(false);
    }
  };

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Record Repair</h4>
        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="Date:"
            name="date"
            rules={[
              {
                required: true,
                message: "Please select the record date!",
              },
            ]}
          >
            <DatePicker
              size="small"
              locale={locale}
              format="DD.MM.YYYY"
              style={{
                width: "50%",
              }}
            />
          </Form.Item>
          <Form.Item name="repairTime" label="Hours spent on repair:">
            <InputNumber
              size="small"
              style={{
                width: "10%",
              }}
            />
          </Form.Item>
          <Form.Item
            label="Mill or unit where the repair was performed:"
            name="scope"
          >
            <Input />
          </Form.Item>

          <Form.Item label="Repair title:" name="title">
            <Input />
          </Form.Item>
          <Form.Item label="Replaced parts:" name="replacedParts">
            <Input.TextArea />
          </Form.Item>

          <Form.Item
            label="Comments, information about the repair"
            name="comment"
          >
            <Input.TextArea />
          </Form.Item>

          <Form.Item>
            <Button type="primary" block size="medium" htmlType="submit">
              Record
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};
